import { environment } from '@environments/environment';

/**
 * Builds the shareable per-user room link shown in the UI for a provider to
 * share with clients (e.g. `https://room.presencelearning.com/<username>`).
 *
 * In production the base is pinned to `environment.room_share_base_url` (the
 * presencelearning.com domain) so the displayed link is stable no matter which
 * domain the app is currently served from (presence.com or
 * presencelearning.com). When no base URL is configured (dev/staging) it falls
 * back to the room app base (`environment.apps.room`).
 */
export function buildRoomShareUrl(username: string): string {
  return `${
    environment.room_share_base_url || environment.apps.room
  }/${username}`;
}
